export default {
    appName: "Supporters group for Governor Umo Eno",
    domain: process.env.NODE_ENV === 'production' ? 'https://support.umoeno.com' : 'http://127.0.0.1:8000',
    localUserKey: "jeiedpkr186e2354d3d94eaa841b_utk"
}
